export default __webpack_public_path__ + "static/img5@2x-1568f6999dd633b281703f31bcda3561.jpg";